export enum EXPERTISE_INFO_COMPONENT_TYPE {
    TEXT,
    SPLITTED_TEXT,
    FIGURES,
    ACTIVITY_AREA
}
